import { useEffect, useState, useMemo } from "react";
import { CreateAuthorizedDataSource } from '~/helpers/data';
import { AdminComponent } from '~/components/admin-component/admin-component';

const URL = `${window.env.apiEndpoint}/api/v1`;

export const EmploymentStatuses = () => {

  const [membershipTypes, setMembershipTypes] = useState([]);

  const membershipTypesStore = useMemo(()=> CreateAuthorizedDataSource(
    {
      loadUrl: `${URL}/MembershipTypes/MembershipTypesLookup`,
    }, null, 'Id',
  ),[]);


  const extraColumns = [
    {
      dataField: "HideFromMemberAccessStaffList",
      dataType: "boolean",
      sortIndex: "0",
    },
    {
      dataField: "HasEffectiveDate",
      dataType: "boolean",
      sortIndex: "0",
    },
    {
      dataField: "ChangeMembershipTypeToId",
      dataType: "number",
      sortIndex: "0",
      caption: "Change Membership Type To",
      lookup: {
        dataSource: membershipTypes,
        valueExpr: "Value",
        displayExpr: "Text",
      },
      editorOptions:{
        showClearButton: true
      },
      customizeText: (cellInfo) => {
        if (!cellInfo.value) {
          return "(Do not change)";
        }
        return cellInfo.valueText;
      }
    }
  ];

  useEffect(() => {
    const loadLookup = async () => {
      let lst = await membershipTypesStore.load();
      setMembershipTypes(lst);
    }
    loadLookup();
  }, [membershipTypesStore]);

  return(
  <AdminComponent
    componentName="EmploymentStatuses"
    title="Employment Statuses"
    extraColumns={extraColumns}
  />)
};
